import React, {Component, PropTypes} from 'react';
import Cannonicalize from '../Cannonicalize'
import ClientSideCacheController from '../ClientSideCacheController'
import Analytics from '../Analytics';
class NwsWeatherAlerts extends Component {
  constructor(props) {
    super(props)
    this.debug = this.props.debug
    this.state = {
      meta: {},
      counties: []
    }
  }

  componentWillMount() {

    try {
      this.setState(  Cannonicalize.nwsAlerts(this.props.FRN_rawResponses[0].data))
    } catch (e) {
      e.message += ' in NwsWeatherAlerts'
      Analytics.reportError(e)
    }
    if (typeof window !== 'object')
      return
    ClientSideCacheController.get('nwsAlerts',{debug: this.debug}).then((res) => {
      this.setState(res)
    })
  }

  render() {

    return (<div className='gnm-nws-weather-alerts'>
      <ul>
        {
          this.state.counties
          .filter(c=>c.dma === this.props.affiliate)
          .map((county, i) => {
            let alertsSummary = ''
            county.alerts.forEach((a,i)=>{
              if( i != 0)
                alertsSummary = alertsSummary + ', '
              alertsSummary = alertsSummary + a.type
            })
            if(!alertsSummary)
              return null
            return (
            <li  key={i}   onClick={()=>{
              let newCounties = this.state.counties
              newCounties[i].open = !newCounties[i].open
              this.setState({counties: newCounties})
            }}>
              <div>
                <span className='county'>{county.countyName} County</span>
                <div className="description open" >
                  {county.alerts.map((a,i)=>{
                    return(
                      <div key={i} className="relative" >
                          <i className='fa fa-circle status-indicator' style={{color: a.hexColor}}  />
                          <a href={a.href} target="_blank">{a.type}</a>  <span>{a.title.replace(a.type, '')}</span>
                      </div>
                    )
                  })

                  }

                </div>
              </div>

            </li>);
          })
        }
      </ul>
    </div>)
  }
}

export default NwsWeatherAlerts



// WEBPACK FOOTER //
// ./app/components/custom/ssr/NwsWeatherAlerts/index.js